














import { Component, Prop, Vue } from 'vue-property-decorator'
import axios from 'axios'
import { SimpleLookupItem } from '../models/SimpleLookupItem'

@Component({
  name: 'IcnRegion'
})
export default class IcnRegion extends Vue {
  @Prop({ required: false, default: 'supplier' }) readonly searchType!: string;

  parameters = {
    state: ''
  }

  subRegions: SimpleLookupItem[] = []

  private async getSubRegionAsync (): Promise<SimpleLookupItem[]> {
    const apiUrl = '/Umbraco/Api/ICNGateway/GetSubRegions'
    const response = await axios.post(`${process.env.VUE_APP_BASE_URL}${apiUrl}`, this.parameters)
    return response.data
  }

  get regionName() {
    return this.searchType == 'supplier' ? 'region' : 'location'
  }

  get subRegionName() {
    return this.searchType == 'supplier' ? 'subregion' : ''
  }

  getSubRegions (): void {
    this.getSubRegionAsync().then((response) => {
        this.subRegions = response
      })
      .catch((error) => {
        console.log(error)
      })
      // .then(() => {
      // })
  }
}
